import {ScrollView, View} from 'react-native';
import {Button} from 'react-native-paper';
import {Text} from '../../Components';
import {PageContainer} from '../../Containers';
import {useTheme} from '../../Hooks';
import {RootOrientationScreenProps} from '../../Typings/NavigationTypes';
import {getCopy} from '../../Utils/I18n';
import getStyles from './ADAPT-MH.styles';

type Props = RootOrientationScreenProps;

const Orientation: React.FC<Props> = ({navigation, route}) => {
  const theme = useTheme();
  const styles = getStyles(theme);
  const {clinical, language} = route.params;
  const copy = getCopy(language);
  const screenCopy = clinical ? copy.clinicalOrientation : copy.orientation;

  const onStartPress = () => {
    if (clinical) {
      navigation.navigate('Questions', {
        mode: 'recommended',
        language,
        assessmentMode: 'guided',
        startedByProvider: true,
        sharingConsent: 'share-summary',
        reset: true,
      });
      return;
    }

    navigation.navigate('Questions', {mode: 'recommended', language, reset: true});
  };

  return (
    <PageContainer withSafeArea withPadding>
      <ScrollView contentContainerStyle={styles.scrollContent}>
        <View style={styles.hero}>
          <Text
            fontSize={30}
            lineHeight={37}
            weight="black"
            accessibilityRole="header"
            style={styles.title}
          >
            {screenCopy.title}
          </Text>
          <Text fontSize={16} lineHeight={24} style={styles.subtitle}>
            {screenCopy.subtitle}
          </Text>
        </View>

        <View style={styles.card}>
          {screenCopy.bullets.map((bullet) => (
            <Text key={bullet} style={styles.listItem}>
              {`- ${bullet}`}
            </Text>
          ))}
        </View>

        {!clinical ? (
          <View style={styles.softCard}>
            <Text weight="semiBold" style={styles.strongBody}>
              {copy.orientation.privacy}
            </Text>
          </View>
        ) : null}

        <Button
          mode="contained"
          onPress={onStartPress}
          style={styles.button}
          buttonColor={theme.colors.primary}
          textColor={theme.colors.textContrast}
        >
          {screenCopy.start}
        </Button>
      </ScrollView>
    </PageContainer>
  );
};

export default Orientation;
